export function runDevtools() {
  setDevmodeFavicon()
}

const setDevmodeFavicon = () => {
  document.head
    .querySelectorAll<HTMLLinkElement>('link[rel=icon]')
    .forEach((link) => (link.href = '/favicons/dev-favicon.svg'))

  const titleEl = document.head.querySelector<HTMLTitleElement>('title')
  if (titleEl) {
    titleEl.innerText = '[dev]' + titleEl.innerText
  }
}
